import axios from 'axios'
import authHeader from './auth-header'

const API_URL = process.env.VUE_APP_API_URL

class PersonalProfileService {
  // fetch all (or the current user’s) personal profiles
  index() {
    return axios.get(API_URL + 'personal-hirings', { headers: authHeader() })
  }

  // fetch a single profile by id
  show(id) {
    return axios.get(API_URL + `personal-hirings/${id}`, { headers: authHeader() })
  }

  // create a new personal profile
  store(resource) {
    return axios.post(API_URL + 'personal-hirings', resource, { headers: authHeader() })
  }

  // update an existing profile
  update(resource) {
    return axios.put(API_URL + `personal-hirings/${resource.id}`, resource, { headers: authHeader() })
  }
}

export default new PersonalProfileService()
